/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import { Box, Button, Typography } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useNavigate } from 'react-router-dom';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import notificationData from './Data';
import NotFound from './NotFound';
const NotificationPage = () => {
    const navigate = useNavigate();
    return (
        <>
            <Box>
                <Button
                    onClick={() => navigate('/')}
                    style={{
                        color: '#1A1F36',
                        fontSize: '24px',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        marginBottom: '24px',
                        textTransform: 'capitalize'
                    }}
                >
                    <KeyboardArrowLeftIcon
                        sx={{ color: '#1760EC', width: '30px', height: '30px' }}
                    />
                    Notification
                </Button>
            </Box>
            <Box className="card-body p-20 bg-base border rounded-3 mt-24">
                <Box sx={{ maxWidth: '800px', margin: 'auto' }}>
                    <Box>
                        <Box sx={{ background: '#5932EA', padding: '10px 25px', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '40px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <Box>
                                    <img style={{ width: '60px', height: '60px', borderRadius: '100%', objectFit: 'contain' }} src='/assets/images/newimages/avatar.png' />
                                </Box>
                                <Box>
                                    <Typography sx={{ color: '#fff', fontSize: '17px', fontWeight: '400' }}>We released some new features</Typography>
                                    <Typography sx={{ color: '#fff', fontSize: '13px', fontWeight: '300' }}>Check them out!</Typography>
                                </Box>
                            </Box>
                            <Box>
                                <ChevronRightOutlinedIcon sx={{ color: '#fff' }} />
                            </Box>
                        </Box>
                        {
                            notificationData.map((item => (
                                <Box sx={{ marginBottom: '20px', borderBottom: '1px solid #ddd', paddingBottom: '20px' }}>
                                    <Box sx={{ display: 'flex', gap: '10px' }}>
                                        {
                                            item.image && (
                                                <Box>
                                                    <img style={{ width: '32px', height: '32px', borderRadius: '100%', objectFit: 'contain' }} src={item.image} />
                                                </Box>
                                            )
                                        }
                                        <Box>
                                            <Typography sx={{ color: '#1A1F36', fontSize: '15px', fontWeight: '500' }}>
                                                {item.name}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box sx={{ marginTop: '8px' }}>
                                        {
                                            item.viewBtn && (
                                                <Button sx={{ background: '#0076FE', color: '#fff', fontSize: '13px', fontWeight: '400', borderRadius: '5px', textTransform: 'capitalize' }}>{item.viewBtn}</Button>
                                            )
                                        }
                                        {
                                            item.undoBtn && (
                                                <Button sx={{ background: '#fff', color: '#3C4257', border: '1px solid #ddd', fontSize: '13px', fontWeight: '400', borderRadius: '5px', textTransform: 'capitalize', marginLeft: '10px' }}>{item.undoBtn}</Button>
                                            )
                                        }
                                    </Box>
                                    <Box>
                                        <Typography sx={{ color: '#A5ACB8', fontSize: '13px', fontWeight: '400', marginTop: '7px' }}>{item.dateVal}</Typography>
                                    </Box>
                                </Box>
                            )))
                        }
                    </Box>

                    <Box>
                        <NotFound />
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default NotificationPage